import React from 'react';
import { mockData } from '../data/mock';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  const { contact } = mockData;
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Accueil', href: '#hero' },
    { label: 'Services', href: '#services' },
    { label: 'Savoir-faire', href: '#about' },
    { label: 'Témoignages', href: '#testimonials' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#1C1917] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img 
              src="https://static.prod-images.emergentagent.com/jobs/e29e1e74-dfad-4ff0-a54e-5cee69b74787/images/bdeeb968c67a238c88bf066835fa5e9366205e516d5318d85119a91bd27eb1b4.png"
              alt="Baya Couture"
              className="h-12 w-auto brightness-0 invert mb-4"
              data-testid="footer-logo"
            />
            <p 
              className="text-white/50 leading-relaxed text-sm"
              style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
            >
              Votre spécialiste en retouches de vêtements et rideaux à Antony. Plus de 10 ans d'expérience.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 
              className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Navigation
            </h4>
            <div className="space-y-3">
              {quickLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-sm text-white/50 hover:text-[#D4AF37] transition-colors"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 
              className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Nos Services
            </h4>
            <div className="space-y-3">
              {['Retouches de vêtements', 'Retouches de rideaux', 'Ourlets sur mesure', 'Réparations textiles'].map((s, i) => (
                <div key={i} className="text-sm text-white/50" style={{ fontFamily: "'Outfit', sans-serif" }}>{s}</div>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 
              className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] font-semibold mb-6"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              Contact
            </h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <span className="text-sm text-white/50" style={{ fontFamily: "'Outfit', sans-serif" }}>{contact.address}</span>
              </div>
              <a href="tel:0149100388" className="flex items-center gap-3 text-white/50 hover:text-[#D4AF37] transition-colors">
                <Phone className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>{contact.phone}</span>
              </a>
              <a href={`mailto:${contact.email}`} className="flex items-center gap-3 text-white/50 hover:text-[#D4AF37] transition-colors">
                <Mail className="w-4 h-4 text-[#D4AF37]" />
                <span className="text-sm" style={{ fontFamily: "'Outfit', sans-serif" }}>{contact.email}</span>
              </a>
              <div className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                <div className="text-sm text-white/50 leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  <div>{contact.hours.weekdays}</div>
                  <div>{contact.hours.weekend}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30" style={{ fontFamily: "'Outfit', sans-serif" }}>
            &copy; {currentYear} Baya Couture. Tous droits réservés.
          </p>
          <p className="text-xs text-white/30" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Antony, France &middot; Service professionnel
          </p>
        </div>

        {/* Large decorative brand name */}
        <div className="mt-8 text-center overflow-hidden">
          <span 
            className="text-[12vw] sm:text-[10vw] font-light text-white/[0.03] leading-none select-none"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            BAYA COUTURE
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
